import React from 'react'

function Footer() {
  return (
    <div>
      <footer style={{'text-align': 'center', 'padding': '20px', 'background-color':' #black', 'color': 'white'}}>
    <p>&copy; 2024 Adrika. All Rights Reserved.</p>
</footer>
    </div>
  )
}

export default Footer
